import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { createClient } from "@supabase/supabase-js";
import "../../dist.css/MealDetailsPage.css"; // Stil dosyasını unutmayın
import Salad from "../../img/salad.gif";
import Hat from "../../img/hat.gif";
import { motion } from "framer-motion";
const supabase = createClient(
  "https://qlgwpthiwclfbgzzjmjw.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFsZ3dwdGhpd2NsZmJnenpqbWp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ2MDUzOTIsImV4cCI6MjA0MDE4MTM5Mn0.N9-IULDnpuUWR_PNXvXyzdTTIMRsxRAxVGrAagaJn4k"
);

const UserMealDetailPage = () => {
  const { id } = useParams();
  const [meal, setMeal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMealDetails = async () => {
      const { data, error } = await supabase
        .from("meals")
        .select("*")
        .eq("id", id) // ID'ye göre filtreleme yapıyoruz
        .single(); // Sadece bir yemek alıyoruz

      if (error) {
        console.error("Hata oluştu:", error);
        setError(error.message);
        setLoading(false);
        return;
      }

      setMeal(data);
      setLoading(false);
    };

    fetchMealDetails();
  }, [id]);

  const handleSpeak = () => {
    if (!window.speechSynthesis) {
      alert("Tarayıcınız metin seslendirme özelliğini desteklemiyor.");
      return;
    }

    const instructions = meal.content.split(" ");
    const utterance = new SpeechSynthesisUtterance(instructions.join(" "));
    utterance.lang = "tr-TR"; // Türkçe dil kodu
    window.speechSynthesis.speak(utterance);
  };

  if (loading) return <div>Yükleniyor...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="meal__details__page">
      <div className="meal__details">
        <motion.div
          className="left__container"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.5, type: "spring" }}
        >
          <img src={meal.image_url} alt="Meal" />
          <div className="meal__name">
            <h2>{meal.title}</h2>
            <p className="meal__area">
              <i className="bx bx-map"></i>
              {meal.area}
            </p>
            <p>Kategori: {meal.category}</p>
          </div>
        </motion.div>

        <div className="body__container">
          <div className="ingredients__container">
            <motion.h2
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{
                duration: 1,
                delay: 1,
                ease: "easeOut",
                type: "spring",
                stiffness: 200,
              }}
            >
              <img src={Salad} alt="Salad" />
              Malzemeler
            </motion.h2>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{
                duration: 1,
                delay: 1.2,
                ease: "easeOut",
                type: "spring",
                stiffness: 200,
              }}
            >
              <ul className="ingredients">
                {meal.materials.split(" ").map((material, index) => (
                  <li key={index} className="ingredient">
                    <div className="ingredient__info">
                      <h2>{material}</h2>
                    </div>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>

          <div className="instruction__container">
            <motion.h2
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{
                duration: 1,
                delay: 1,
                ease: "easeOut",
                type: "spring",
                stiffness: 200,
              }}
            >
              <img src={Hat} alt="Hat" />
              Talimatlar
            </motion.h2>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{
                duration: 1,
                delay: 1.2,
                ease: "easeOut",
                type: "spring",
                stiffness: 200,
              }}
            >
              <div className="instruction">
                {meal.content.split(" ").map((instruction, index) => (
                  <p key={index}>
                    <i className="bx bx-cube-alt"></i>
                    {instruction}
                  </p>
                ))}
              </div>
              <button className="find__btn btn" onClick={handleSpeak}>
                Talimatları Seslendir
              </button>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserMealDetailPage;
